import { FC, useEffect, useRef, useState, useMemo } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useForm, Controller } from 'react-hook-form';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery, useMutation } from 'react-query';
import { AdminUserInfoFormInput } from './types';
import { EndUserProfileInfo } from 'domain/user';
import { Grid, TextField, FormControl, Tooltip } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { observer } from 'mobx-react-lite';
import { toFormatDateTime } from 'utils';
import sampleImg from '../../../assets/sample.svg';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
export const SecondaryAdminUserProfileForm: FC = observer(() => {
  const classes = useStyles();
  const [imgFile, setImgFile] = useState<File | undefined | string | any>('same');
  const [imageSize, setImageSize] = useState(true);
  const [imgSrc, setImgSrc] = useState<string>();
  const [groups, setGroups] = useState<string[]>([]);
  const [department, setDepartment] = useState('');
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const {
    userStore: { token, user, getProfile, endUserProfileInfo, getSystemUserProfileInfo, updateEndUserProfileInfo },
    ldapStore: { groupsView, getGroup },
    notificationStore: { openNotification },
  } = useStore();

  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const getDataReq = useQuery('getDataReq', () => getGroup(profile.id), {
    onError: () => openNotification('error', `Can't get groups data`),
  });
  const getUserProfileinfo = useQuery('getUserProfileInfo', () => getSystemUserProfileInfo(), {
    onError: (e) => {
      openNotification('error', `Can't get admins profile info`);
    },
  });
  const updateUserProfileInfoReq = useMutation((data: EndUserProfileInfo) => updateEndUserProfileInfo(data), {
    onSuccess: () => {
      openNotification(
        'success',
        `Your request to update the profile has been submitted to the administrator.Once approved the profile will be automatically updated.`
      );
      getUserProfileinfo.refetch();
      // getProfileReq.refetch();
    },
    onError: ({ message }: Error) => openNotification('error', message),
  });
  const getProfileReq = useQuery('getProfileInitialReq', () => getProfile(), {
    enabled: !!token && !(!!user as boolean),
    onError: () => openNotification('error', `Can't get user profile`),
  });

  useAppPreloader(
    getProfileReq.isFetching ||
      getUserProfileinfo.isFetching ||
      getDataReq.isFetching ||
      updateUserProfileInfoReq.isLoading
  );

  const { control, handleSubmit, setValue } = useForm<EndUserProfileInfo>();
  const cnList = useMemo(() => groupsView.map((item) => item.cn), [groupsView]);
  useEffect(() => {
    if (JSON.stringify(groups) !== JSON.stringify(cnList)) {
      setGroups(cnList);
    }
  }, [groups, cnList, setGroups]);
  useEffect(() => {
    setValue('groups', groups.join(', '));
  }, [groups, setValue]);
  const onSubmit = (data: EndUserProfileInfo) => {
    data.profileImg = imgFile;
    return updateUserProfileInfoReq.mutate(data);
  };

  const organizationBlockMock1: AdminUserInfoFormInput<EndUserProfileInfo>[] = [
    { name: 'firstName', title: 'First Name', placeholder: 'First Name', required: true },
    { name: 'middleName', title: 'Middle Name', placeholder: 'Middle Name', required: true },
    { name: 'lastName', title: 'Last Name', placeholder: 'Last Name', required: true },
    { name: 'email', title: 'Email', placeholder: 'abc@xyz.com', required: true, disabled: true },
  ];
  const organizationBlockMock2: AdminUserInfoFormInput<EndUserProfileInfo>[] = [
    { name: 'phone', title: 'Phone:', placeholder: 'Phone number', required: false },
    { name: 'personalAddress', title: 'Personal Address', placeholder: 'Postal Address', required: false },
    // { name: 'roles', title: 'Roles:', placeholder: 'Roles', disabled: true },
    { name: 'groups', title: 'Groups', placeholder: 'Groups', disabled: true },
    { name: 'departments', title: 'Department', placeholder: 'Department', disabled: true },
    { name: 'organizationName', title: 'Organization Name', placeholder: 'Organization Name', disabled: true },
    { name: 'address', title: 'organizationAddress', placeholder: 'Billing Address', disabled: true },
  ];

  function handleChange(e: { target: { files: (Blob | MediaSource)[] | FileList | any } }) {
    if (e.target.files.length !== 0) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        // img.onload = () => {
        //   const maxWidth = 110;
        //   const maxHeight = 200;
        //   let width = img.width;
        //   let height = img.height;
        //   if (width > maxWidth || height > maxHeight) {
        //     const aspectRatio = width / height;
        //     if (width > height) {
        //       width = maxWidth;
        //       height = width / aspectRatio;
        //     } else {
        //       height = maxHeight;
        //       width = height * aspectRatio;
        //     }
        //   }
        //   const canvas = document.createElement('canvas');
        //   canvas.width = width;
        //   canvas.height = height;
        //   const ctx = canvas.getContext('2d');
        //   if (ctx) {
        //     ctx.drawImage(img, 0, 0, width, height);
        //     canvas.toBlob(
        //       (blob) => {
        //         const resizedFile = new File([blob as Blob], file.name, {
        //           type: 'image/jpeg',
        //           lastModified: Date.now(),
        //         });
        //         setImgFile(resizedFile);
        //         setImgSrc(canvas.toDataURL());
        //       },
        //       'image/jpeg',
        //       0.9
        //     );
        //   }
        // };
        img.src = event.target?.result as string;
      };
      reader.readAsDataURL(file);
    }
  }
  useEffect(() => {
    setImgSrc(
      !getUserProfileinfo.isFetching && endUserProfileInfo?.profileUrl ? `${endUserProfileInfo?.profileUrl}` : sampleImg
    );
  }, [endUserProfileInfo?.profileUrl, getUserProfileinfo.isFetching]);
  useEffect(() => {
    const ValueGroup = endUserProfileInfo?.groups;
    if (ValueGroup) {
      // let cnValues = [];

      // Handle both string and array types
      if (typeof ValueGroup === 'string') {
        try {
          const parsedValueGroup = JSON.parse(ValueGroup);
          if (Array.isArray(parsedValueGroup)) {
            parsedValueGroup
              .map((group) => {
                const match = group.match(/cn=([^,]+)/);
                return match ? match[1] : null;
              })
              .filter(Boolean);
          }
        } catch (e) {
          ValueGroup.split(',')
            .map((group) => {
              const match = group.match(/cn=([^,]+)/);
              return match ? match[1] : null;
            })
            .filter(Boolean);
        }
      }
    } else {
      setGroups([]);
    }
  }, [endUserProfileInfo?.groups]);

  useEffect(() => {
    const ValueDepartment = endUserProfileInfo?.departments;
    if (ValueDepartment) {
      // Handle both string and array types
      if (typeof ValueDepartment === 'string') {
        const department = ValueDepartment.substring(1);
        setDepartment(department);
      } else {
        setDepartment('');
      }
    } else {
      setDepartment('');
    }
  }, [endUserProfileInfo?.departments]);
  const LightTooltip = () => {
    return (
      <div style={{ display: 'flex' }}>
        <LightbulbIcon />
        <span style={{ lineHeight: '10px' }}>Formats: jpeg, gif, bmp. File size (max): 2 MB</span>
      </div>
    );
  };
  return !getUserProfileinfo.isFetching ? (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
      <Grid className={classes.btnContainer}>
        <Button className={classes.btn} type='submit' variant='contained' disabled={imageSize === false}>
          Save Changes
        </Button>
      </Grid>
      <div className={classes.formContainer}>
        <div style={{ marginTop: '0px' }} className={classes.heading}>
          General Information
        </div>
        <div className={classes.leftCol}>
          <div className={classes.profileContainer}>
            <img className={classes.profilePicture} src={imgSrc} alt='profile' />
          </div>

          <div className={classes.uploadBtnContainer}>
            <input
              accept='image/jpeg,image/gif,image/bmp'
              style={{ display: 'none' }}
              id='profile-picture'
              type='file'
              onChange={handleChange}
            />
            <canvas ref={canvasRef} style={{ display: 'none' }} />

            <label htmlFor='profile-picture'>
              <Tooltip title={<LightTooltip />} classes={{ tooltip: classes.tooltip }} arrow placement='top'>
                <Button component='span' className={classes.link2} variant='contained' color='secondary'>
                  + Upload New Picture
                </Button>
              </Tooltip>
            </label>
          </div>
          <div className={classes.removeBtnContainer}>
            <Button
              className={classes.link}
              variant='outlined'
              onClick={() => {
                setImgFile(undefined);
                setImgSrc(sampleImg);
                setImageSize(true);
              }}
            >
              Remove
            </Button>
          </div>
        </div>
        <div className={classes.rightCol}>
          <Grid container justify='space-between' className={classes.container}>
            <Grid className={classes.block} container>
              {organizationBlockMock1.map((item, index: number) => (
                <Controller
                  key={index}
                  name={item.name}
                  defaultValue={endUserProfileInfo?.[item.name]}
                  control={control}
                  rules={{ required: item?.required }}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container className={classes.row}>
                      <TextField
                        {...field}
                        label={item.title}
                        disabled={item.disabled}
                        error={invalid}
                        placeholder={item.placeholder}
                        helperText={invalid ? 'Required field' : ''}
                        className={classes.input}
                      />
                    </Grid>
                  )}
                />
              ))}
              {organizationBlockMock2.map((item, index: number) =>
                item.name === 'phone' ? (
                  <Controller
                    key={index}
                    name={item.name}
                    defaultValue={endUserProfileInfo?.[item.name]}
                    control={control}
                    rules={{ required: item?.required }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.row}>
                        <FormControl fullWidth>
                          <MuiPhoneNumber
                            {...field}
                            label={item.title}
                            disabled={item.disabled}
                            error={invalid}
                            placeholder={item.placeholder}
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                            data-cy='user-phone'
                            defaultCountry={'us'}
                            variant='standard'
                            color='warning'
                          />
                        </FormControl>
                      </Grid>
                    )}
                  />
                ) : item.name === 'departments' ? (
                  <>
                    <Controller
                      key={index}
                      name={item.name}
                      defaultValue={department}
                      control={control}
                      rules={{ required: item?.required }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container className={classes.row}>
                          <TextField
                            {...field}
                            label={item.title}
                            disabled={item.disabled}
                            error={invalid}
                            placeholder='department'
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                          />
                        </Grid>
                      )}
                    />
                  </>
                ) : item.name === 'groups' ? (
                  <>
                    <Controller
                      key={index}
                      name={item.name}
                      defaultValue={groups.join(', ')}
                      control={control}
                      rules={{ required: item?.required }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container className={classes.row}>
                          <TextField
                            {...field}
                            label={item.title}
                            value={groups.join(', ')}
                            disabled={item.disabled}
                            error={invalid}
                            placeholder={item.placeholder}
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                          />
                        </Grid>
                      )}
                    />
                  </>
                ) : (
                  <Controller
                    key={index}
                    name={item.name}
                    defaultValue={endUserProfileInfo?.[item.name]}
                    control={control}
                    rules={{ required: item?.required }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.row}>
                        <TextField
                          {...field}
                          label={item.title}
                          disabled={item.disabled}
                          error={invalid}
                          placeholder={item.placeholder}
                          helperText={invalid ? 'Required field' : ''}
                          className={classes.input}
                        />
                      </Grid>
                    )}
                  />
                )
              )}

              <Controller
                name='lastLogin'
                defaultValue={
                  endUserProfileInfo?.lastLogin ? toFormatDateTime(endUserProfileInfo?.lastLogin.toString()) : '-'
                }
                control={control}
                render={({ field, fieldState: { invalid } }) => (
                  <Grid container className={classes.row}>
                    <TextField
                      {...field}
                      label='Last Login'
                      disabled
                      error={invalid}
                      placeholder='-'
                      helperText={invalid ? 'Required field' : ''}
                      className={classes.input}
                    />
                  </Grid>
                )}
              />
            </Grid>
          </Grid>
        </div>
      </div>
    </form>
  ) : null;
});
